import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
import { Stack } from '@mui/material';

import { ErrorState, PageHeader, StateDisplay } from '@/components/common';
import { DetailPageSkeleton } from '@/components/common/Skeletons';

import { PendingInvitationsList } from '../components/PendingInvitationsList';
import { useMyInvitations } from '../hooks/useMyInvitations';

/**
 * The always-available discovery surface for company invitations (Invitation Discovery). Lists every
 * pending invitation addressed to the signed-in user's own verified email — resolved server-side from
 * their identity, never a client-supplied address — with Accept / Decline per row. Lives under
 * /account so every persona reaches it from the account menu.
 */
export function MyInvitationsPage() {
  const { invitations, loading, error, refetch } = useMyInvitations();

  if (loading) return <DetailPageSkeleton />;
  if (error) {
    return <ErrorState title="Could not load your invitations" onRetry={() => void refetch()} />;
  }

  return (
    <Stack spacing={3}>
      <PageHeader
        title="Company invitations"
        description="Invitations to join a company workspace, sent to your email address."
      />

      {invitations.length === 0 ? (
        <StateDisplay
          tone="secondary"
          icon={<MarkEmailReadOutlinedIcon />}
          title="No pending invitations"
          description="When a company invites you to their workspace, it will appear here for you to accept or decline."
        />
      ) : (
        <PendingInvitationsList invitations={invitations} />
      )}
    </Stack>
  );
}
